function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import FullBackgroundTextAndAsset from "segments/desktop/core-components/full-background-text-and-asset/full-background-text-and-asset";
import FullBackgroundTextAndAssetDefaultProps from "segments/desktop/core-components/full-background-text-and-asset/default-props";
import { MD } from "constants/sizes";
import classnames from "classnames";
import { componentStyles } from "./full-background-text-and-asset-component.scss";
const FullBackgroundTextAndAssetComponent = (props)=>{
    const { height, alignToLogo } = props;
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            height
        },
        className: `jsx-${componentStyles.__hash}` + " " + (classnames("full-background-text-and-asset-component", {
            "align-to-logo": alignToLogo
        }) || ""),
        children: [
            /*#__PURE__*/ _jsx(FullBackgroundTextAndAsset, _object_spread({}, props)),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
FullBackgroundTextAndAssetComponent.defaultProps = _object_spread_props(_object_spread({}, FullBackgroundTextAndAssetDefaultProps), {
    titleSize: MD,
    textSize: MD,
    height: "650px",
    alignToLogo: true
});
export default FullBackgroundTextAndAssetComponent;
